import { Props } from '@service-victoria/component-library';

import addressService from './addressService';

/**
 * Retrieve a list of addresses
 * @param baseURL base URL for address search API
 */
export function getAddressesLookup(
  baseURL: string,
  transactionType: string
): (search: string) => Promise<Props.AutoComplete.OptionType[]> {
  return new addressService(baseURL, transactionType).getAddressesLookup;
}

/**
 * Retrieve the full details of the address
 * @param baseURL base URL for address search API
 */
export function getAddressDetails(
  baseURL: string,
  transactionType: string
): (addressId: string) => Promise<Props.AddressLookup.Interfaces.ApiFullAddress> {
  return new addressService(baseURL, transactionType).getAddressDetails;
}
